export let NewsroomDomain;
(function (_NewsroomDomain) {
  let Type = /*#__PURE__*/function (Type) {
    Type["PREZLY"] = "prezly";
    Type["CUSTOM"] = "custom";
    Type["REVERSE_PROXY"] = "reverse_proxy";
    return Type;
  }({});
  _NewsroomDomain.Type = Type;
  let Status = /*#__PURE__*/function (Status) {
    Status["ACTIVE"] = "active";
    Status["INACTIVE"] = "inactive";
    Status["REDIRECT"] = "redirect";
    return Status;
  }({});
  _NewsroomDomain.Status = Status;
})(NewsroomDomain || (NewsroomDomain = {}));